<script lang="ts">
	let { text, name } = $props();
</script>

<div
	class="embla__slide preset-tonal-outlined flex shrink-0 grow-0 basis-full flex-col justify-between gap-2 rounded-xl p-3 shadow select-none lg:max-w-110"
>
	<p class="leading-relaxed lg:text-lg">
		{text}
	</p>
	<div class="flex items-center gap-2">
		<div class="text-sm lg:text-base">&mdash; {name}</div>
	</div>
</div>
